import * as types from '../tools/constants'
import chair from '../../assets/img/chair.png'
import sample from '../../assets/img/sample.jpg'
import sample2 from '../../assets/img/sample2.jpg'
import INITIAL_DATA from '../../initial-data.json'

const Faces = { Up: 'Up', Right: 'Right', Left: 'Left' }
const Planes = { One: '1', Two: '2', Three: '3' }

let initialData = JSON.parse(window.localStorage.getItem('rooms'))
if (!initialData) {
    initialData = INITIAL_DATA
    window.localStorage.setItem('rooms', JSON.stringify(INITIAL_DATA))
}
initialData = {
    ...initialData,
    error: null,
    loading: false,
    room: null,
    rooms: [],
    isDrawing: false,
    multiply: 0.8,
    brightness: -50,
    contrast: 20,
    zoom: 100,
    offsetH: 0,
    offsetV: 0,
    grayScaleImages: [],
    isPhotoEditorVisible: false,
}

const reducer = (state = initialData, actions) => {
    switch (actions.type) {
        case types.SET_PHOTO_EDITOR_MATERIAL:
            return {
                ...state,
                photoEditorMaterial: actions.payload,
                isPhotoEditorVisible: true,
            }
        case types.CLOSE_PHOTO_EDITOR_MATERIAL:
            return {
                ...state,
                isPhotoEditorVisible: false,
            }
        case types.OPERATION_STARTED:
            return {
                ...state,
                loading: true,
                error: null,
            }
        case types.OPERATION_FAILED:
            return {
                ...state,
                loading: false,
                error: actions.payload,
            }
        case types.GET_MATERIALS_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                allMaterials: actions.payload,
            }
        case types.GET_ROOMS_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                rooms: actions.payload,
            }
        case types.GET_ROOM_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                room: actions.payload,
            }
        case types.UPLOAD_MATERIAL_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
            }
        case types.RESET_MATERIAL_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
            }
        case types.EDIT_MATERIAL_TITLE_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
            }
        case types.EDIT_ROOM_TITLE_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
            }
        case types.DELETE_MATERIAL_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
            }
        case types.DELETE_ROOM_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
            }
        case types.UPLOAD_ROOM_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
            }
        case types.ACTIVE_PATH:
            return {
                ...state,
                hoveredPathId: actions.payload,
            }
        case types.CHOOOSE_ROOM:
            return {
                ...state,
                roomInDesignStage: actions.payload,
                multiply: 0.8,
                loading: false,
            }
        case types.CHOOSE_ROOM_INITIAL:
            var newState = { ...state, loading: true }
            if (state.roomInDesignStage) {
                delete newState.roomInDesignStage.selectedPrespectives
                delete newState.roomInDesignStage
            }
            return newState
        case types.RESET_DRAG:
            return {
                ...state,
                dragKey: state.dragKey + 1,
                roomInDesignStage: actions.payload,
            }
        case types.SELECT_CURVE:
            return {
                ...state,
                choosedPrespective:
                    state.roomInDesignStage.selectedPrespectives?.find(
                        (q) => q.id == actions.payload
                    ) ?? null,
                isMiniEditorVisible: true,
                brightness:
                    state.roomInDesignStage.selectedPrespectives?.find(
                        (q) => q.id == actions.payload
                    )?.brightness ?? 0,
                contrast:
                    state.roomInDesignStage.selectedPrespectives?.find(
                        (q) => q.id == actions.payload
                    )?.contrast ?? 0,
                zoom:
                    state.roomInDesignStage.selectedPrespectives?.find(
                        (q) => q.id == actions.payload
                    )?.zoom ?? 100,
                offsetH:
                    state.roomInDesignStage.selectedPrespectives?.find(
                        (q) => q.id == actions.payload
                    )?.offsetH ?? 0,
                offsetV:
                    state.roomInDesignStage.selectedPrespectives?.find(
                        (q) => q.id == actions.payload
                    )?.offsetV ?? 0,
            }
        case types.APPLY_CURVE_FILTER:
            return {
                ...state,
                brightness: actions.payload.brightness,
                contrast: actions.payload.contrast,
                roomInDesignStage: actions.payload.room,
            }
        case types.APPLY_TEXTURE_ZOOM:
            return {
                ...state,
                zoom: actions.payload.zoom,
                offsetH: actions.payload.offsetH,
                offsetV: actions.payload.offsetV,
                roomInDesignStage: actions.payload.room,
            }
        case types.CHANGE_CURVE_MULTIPLY:
            return {
                ...state,
                multiplyIntensity: actions.payload,
            }
        case types.DRAWING_STARTED:
            return {
                ...state,
                isDrawing: true,
            }
        case types.DRAWING_ENDED:
            return {
                ...state,
                isDrawing: false,
            }
        case types.CHANGE_MULTIPLY:
            return {
                ...state,
                multiply: actions.payload.value,
            }
        case types.SAVE_GRAY_SCALE_IMAGES:
            return {
                ...state,
                grayScaleImages: actions.payload,
            }
        default:
            return state
    }
}

export default reducer
